import { Injectable, inject } from "@angular/core";
import { CanActivate } from "@angular/router";
import { environment } from "src/environments/environment";
import { LocaleService } from "src/app/services/locale.service";
import { MemberStorageService } from "src/app/services/member-storage.service";
import { sntLog } from "src/app/common/logger";

const logger = sntLog("ProvideBaseLocaleOverrideGuard");

@Injectable()
export class ProvideBaseLocaleOverrideGuard implements CanActivate {
  private readonly localeService = inject(LocaleService);
  private readonly memberStorageService = inject(MemberStorageService);

  async canActivate(): Promise<boolean> {
    const localeParam = new URL(location.href).searchParams.get("locale");
    if (localeParam) {
      if (environment.snoots.languages.supported.includes(localeParam)) {
        this.memberStorageService.setItem("locale", localeParam);
      }
    }

    const localeToSet = await this.localeService.getLocaleWanted();

    await this.localeService.setLocale(localeToSet);

    logger.debug(`localeToSet: ${localeToSet}`);

    return true;
  }
}
